"use client";

import { motion } from "framer-motion";

export const AnimatedGradientText = ({ children }: { children: string }) => {
  return (
    <motion.span
      className="inline-block"
      style={{
        background:
          "linear-gradient(90deg, #3b82f6, #8b5cf6, #ec4899, #3b82f6, #8b5cf6)",
        backgroundSize: "300% 100%",
        backgroundRepeat: "no-repeat",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        backgroundClip: "text",
        MozBackgroundClip: "text",
        willChange: "background-position",
        textShadow: "0 0 1px rgba(0,0,0,0.1)",
      }}
      animate={{
        backgroundPositionX: ["0%", "100%"],
      }}
      transition={{
        duration: 4,
        ease: "linear",
        repeat: Infinity,
      }}
    >
      {children}
    </motion.span>
  );
};
